import { render, staticRenderFns } from "./CopyrightAssignmentTerms.vue?vue&type=template&id=b2ba42a8&scoped=true&"
import script from "./CopyrightAssignmentTerms.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTerms.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTerms.vue?vue&type=style&index=0&id=b2ba42a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ba42a8",
  null
  
)

export default component.exports